/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {useAppDispatch} from '../../../../redux/hooks'
import {forgotPassword} from '../../../../redux/password/passwordSlice'
import {showErrorMessage, showSuccessMessage} from '_metronic/helpers/swalHelper'

const initialValues = {
  email: '',
}

export function ForgotPassword() {
  const {t} = useTranslation()
  const forgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .min(3, t('VALIDATION.MIN_CHARACTER_', {quantity: 3}))
      .max(50, t('VALIDATION.MAX_CHARACTER_', {quantity: 50}))
      .required(t('VALIDATION.REQUIRED_', {name: t('PROFILE.EMAIL')}))
      .email(t('PROFILE.EMAIL_FORMAT')),
  })
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const formData = new FormData()
        formData.append('email', values.email)

        dispatch(forgotPassword(formData)).then((res: any) => {
          if (res.meta.requestStatus === 'fulfilled') {
            showSuccessMessage(t('MESSAGES.EMAIL_SEND_SUCCESSFULLY'), () => {})
          } else if (res.meta.requestStatus === 'rejected') {
            showErrorMessage(t('MESSAGES.' + res.payload.email))
          }

          setLoading(false)
          setSubmitting(false)
        })
      } catch (error: any) {
        if (error.response) {
          if (error.response.status === 404) {
            setStatus(t('MESSAGES.NOT_FOUND_ERROR'))
          } else {
            setStatus(error.response.data.message)
          }
        } else if (error.request) {
        } else {
          console.log('Error', error.message) // General error
        }
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const toTitleCase = (str: string): string => {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase())
  }

  return (
    <div className='container-lg d-lg-flex justify-content-lg-center py-20 px-10'>
      <form className='form w-lg-50 shadow p-4' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Heading */}
        <div className='text-center'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logo/umef-logo.png')} className='h-100px' />
          <h1 className='text-dark fw-bolder my-4'>{t('GLOBAL.FORGOT_PASSWORD')}</h1>
        </div>
        {/* begin::Heading */}

        {/* begin::Form group */}
        <div className='fv-row mb-3'>
          <label className='form-label fs-6 fw-bolder text-dark py-2'>{t('PROFILE.EMAIL')}:</label>
          <input
            placeholder={t('PROFILE.EMAIL_PLACEHOLDER')}
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
            type='email'
            name='email'
            autoComplete='off'
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger fw-bold'>
                {formik.errors.email}
              </span>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Action */}
        <div className='d-grid py-4'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary fw-bold'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>{t('GLOBAL.RESET_PASSWORD')}</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                {t('GLOBAL.PLEASE_WAIT')}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        <Link to='/auth'>{toTitleCase(t('GLOBAL.LOGIN_PAGE'))}</Link>
      </form>
    </div>
  )
}
